import { render, staticRenderFns } from "./EventPreviewBaseCardDesktop.vue?vue&type=template&id=ac585d48&scoped=true"
import script from "./EventPreviewBaseCardDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventPreviewBaseCardDesktop.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventPreviewBaseCardDesktop.vue?vue&type=style&index=0&id=ac585d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac585d48",
  null
  
)

export default component.exports